<template>
  <!-- prettier-ignore -->
  <div
    cy-section="product-categories"
    :class="classes"
  >
    <template v-for="category in categories">
      <ovp-product-category
        :key="personId + category.id + category.available"
        class="categories-category"
        :class="{'categories-category--selected': category.id === categoryId}"
        :category="category"
        :collapsed="!!categoryId"
        :person-id="personId"
        :selected="category.id === categoryId"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import OvpProductCategory from '@/components/Product/Category'

export default {
  name: 'Categories',

  components: {
    OvpProductCategory,
  },

  props: {
    categoryId: {
      type: String,
      default: null,
    },

    collapsed: {
      type: Boolean,
      required: true,
    },

    personId: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.$el.addEventListener('touchstart', e => {
      e.stopPropagation()
    })
    this.$el.addEventListener('touchend', e => {
      e.stopPropagation()
    })
  },

  computed: {
    ...mapGetters('basket', ['getCategories', 'getProductsFromCategory']),

    categories() {
      return this.getCategories(this.personId)
        .filter(category => !category.hidden)
        .map(category => {
          const products = this.getProductsFromCategory(this.personId, category.id)
          category.reductions = products
            .find(product => product.prices.find(p => p.selected && p.reductions.length > 0))
            ?.prices.find(p => p.selected).reductions

          return category
        })
    },

    classes() {
      return {
        categories: true,
        'categories--collapsed': this.categoryId,
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.categories {
  display: grid;
  gap: 20px;
  padding: 0 0 25px 0;

  &--collapsed {
    padding: 0;
    grid-template-columns: repeat(3, minmax(min-content, 1fr));
    grid-template-rows: 1fr;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .categories {
    grid-template-columns: repeat(3, minmax(min-content, 1fr));
    grid-template-rows: 1fr;
  }
}
</style>
